import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    modalBorrowerNotesDialogActions: {
      justifyContent: 'flex-end !important',
    },
    transitionOverflow: {
      overflowX: 'hidden',
    },
  }),
  {index: 1},
);

export default useStyles;
